import { Link } from "react-router-dom";
import { Sprig } from "../components/ProductVisual";

const NotFound = () => (
  <div className="mx-auto flex max-w-7xl flex-col items-center px-4 pb-28 pt-44 text-center" data-testid="not-found-page">
    <Sprig className="h-14 w-auto text-sage-deep" />
    <h1 className="mt-8 font-serif text-4xl font-light italic md:text-5xl">This page doesn't exist.</h1>
    <p className="mt-4 max-w-sm text-sm leading-relaxed text-ink/60">
      Let's get you back to something that does.
    </p>
    <Link to="/" data-testid="not-found-home" className="mt-10 rounded-full bg-ink px-8 py-4 text-[13px] uppercase tracking-[0.2em] text-cream transition-colors hover:bg-ink-deep">
      Back to Home
    </Link>
  </div>
);

export default NotFound;
